import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/Journey/Journey.css";
import { useContext } from "react";
import JourneyRightSection from "./JourneyForm";
// import JourneyLeftSection from "../components/JourneyLeftSection/JourneyLeftSection";
import LoanAgreementModal from "../components/Modal/LoanAgreementModal/LoanAgreementModal";
// * Context/Providers
import LoanAgreementModalContext from "../context/LoanAgreementModalContextProvider";

export default function JourneyPage() {
  const { toggleModal } = useContext(LoanAgreementModalContext);

  return (
    <>
      <main className="journeyMainSection" >
        {/* <JourneyLeftSection /> */}
        <JourneyRightSection />
        {toggleModal && <LoanAgreementModal />}
      </main>
    </>
  );
}
